/*
 * GoalListItem.jsx 02.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import LayersIcon from '@material-ui/icons/Layers';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';

import Notification from '../core/Notification';

const dateFormat = 'DD.MM.YYYY';

const styles = theme => ({
    card: {
        width: '90%',
        margin: '0.8rem auto',
        borderRadius: 4,

        backgroundColor: '#4B4B5D',
        cursor: 'pointer'
    },

    cardContent: {
        display: 'grid',
        gridTemplateColumns: '65% 5% 23% 3%',
        gridTemplateAreas: '"goalNote goalNote goalNote ." "goalText . goalStart ." "goalText goalCheckIcon goalEnd goalResultsIcon"',

        '&:last-child': {
            padding: '0 0 8px 0'
        }
    },

    goalText: {
        gridArea: 'goalText',

        margin: '1rem 0 0 1.5rem',

        verticalAlign: 'top',
        lineHeight: '24px',
        maxHeight: '48px',
        overflow: 'hidden'
    },

    goalStart: {
        gridArea: 'goalStart',

        margin: '1rem 1rem 0 0'
    },

    goalEnd: {
        gridArea: 'goalEnd',

        margin: '0 1rem 0 0'
    },

    goalNote: {
        gridArea: 'goalNote',

        margin: '1rem 1rem 0.5rem 0.5rem'
    },

    checkIcon: {
        gridArea: 'goalCheckIcon',

        marginTop: '8px',

        color: theme.palette.text.primary,
        fontSize: 'small'
    },

    goalResultIcon: {
        gridArea: 'goalResultsIcon',
        marginTop: '8px',
        color: theme.palette.text.primary
    },

    selectedCard: {
        backgroundColor: '#727388'
    },

    title: {
        display: 'inline-block',
        width: 230,
        marginRight: 50
    },

    date: {
        display: 'inline-block',
        width: 120
    },

    gapBox: {
        width: '90%',
        minHeight: 50,
        margin: '0.8rem auto',
        borderRadius: 4,

        background: 'repeating-linear-gradient(45deg, transparent, transparent 3px, #4B4B5D 3px, #4B4B5D 10px)',
        boxShadow: 'none',

        color: theme.palette.text.primary
    },

    gapBoxContent: {
        padding: '1rem 0.5rem',
        display: 'grid',
        gridTemplateColumns: '72% 28%',
        gridTemplateAreas: '"gapNote gapStart" "gapNote gapEnd"'
    },

    gapNote: {
        gridArea: 'gapNote',
        margin: '0 1rem 0 0.5rem'
    },

    gapStart: {
        gridArea: 'gapStart',
        margin: '0 1rem 0 0'
    },

    gapEnd:{
        gridArea: 'gapEnd',
        margin: '0 1rem 0 0'
    }
});

/**
 * Private Komponente zur Darstellung von Zeiträumen ohne Zieldokumentation
 */
class GapItem extends React.Component {

    render() {
        const {classes, data} = this.props;

        return (
            <Card classes={{root: classes.gapBox}}>

                <CardContent classes={{root: classes.gapBoxContent}}>
                    <div className={classes.gapNote}>
                        <Notification message={'Zeitraum ohne Ziel!'} />
                    </div>
                    <Typography className={classes.gapStart} color="textPrimary" noWrap>{format(data.anfang, dateFormat)} -</Typography>
                    <Typography className={classes.gapEnd} color="textPrimary" noWrap>{format(data.ende, dateFormat)}</Typography>
                </CardContent>
            </Card>
        );
    }

}


class GoalListItem extends React.Component {

    render() {
        const {classes, data, notifications} = this.props;

        if (data.id.startsWith('gap')) {
            return <GapItem classes={classes} data={data} />;
        }

        return (
            <Card onClick={this.props.onSelect.bind(this, data)} classes={{root: classes.card}}
                className={this.props.selected ? classes.selectedCard : null} raised={this.props.selected}>

                <CardContent classes={{root: classes.cardContent}}>
                    <div className={classes.goalNote}>
                        {notifications && notifications.map((n, index) => <Notification key={index} type={n.type} message={n.message} />)}
                    </div>
                    <Typography className={classes.goalText} color="textPrimary">{data.zielvereinbarung}</Typography>
                    <Typography className={classes.goalStart} color="textPrimary" noWrap>{format(data.anfang, dateFormat)} -</Typography>
                    {data.zielerreicht && <CheckIcon className={classes.checkIcon}/>}
                    <Typography className={classes.goalEnd} color="textPrimary" noWrap>{format(data.zielerreicht ? data.zielerreichtAm : data.ende, dateFormat)}</Typography>
                    {data.umsetzungVorhanden && <LayersIcon className={classes.goalResultIcon}/>}


                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(GoalListItem);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/detail/GoalListItem.jsx